var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.69 260.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #37474f;\n      }\n\n      .cls-3 {\n        fill: #455a64;\n      }\n\n      .cls-4 {\n        fill: #a6a6a6;\n      }\n\n      .cls-5 {\n        fill: #767676;\n      }\n\n      .cls-6 {\n        fill: #994255;\n      }\n\n      .cls-7 {\n        fill: #ffc727;\n      }\n\n      .cls-8, .cls-9 {\n        opacity: .1;\n      }\n\n      .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-10 {\n        fill: #263238;\n      }\n\n      .cls-11 {\n        fill: #bd4f5c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-4--inject-65"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 184.67,
    y: 13.35,
    width: 24.09,
    height: 35.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 201.26,
    y: 13.35,
    width: 8.82,
    height: 35.45
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 181.99,
    y: 8.29,
    width: 30.76,
    height: 6.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m226.18,52.31h.66v4.6l-92.65-35.56L26.26,69.58v-17.27h.65l-.65-2.29L126.56,10.24s100.49,37.34,100.28,38.56c-.08.5-.36,1.97-.66,3.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "226.84 56.91 226.84 260.56 26.26 260.56 26.26 69.58 134.19 21.35 226.84 56.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m222.05,260.54h34.64s-1.14-4.88-3.44-5.23c-1.41-.12-2.76.64-3.37,1.93,0,0,.11-6.82-4.18-7.97s-7.89,4.86-7.89,4.86c0,0-2.69-3.44-6.36-3.22-3.67.22-4.59,5.89-4.59,5.89,0,0-3.34-1.97-4.81,3.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 194.61,
    y: 139.76,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 202.24,
    y: 132.45,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 186.97,
    y: 132.45,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 158.76,
    y: 63.32,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 151.92,
    y: 70.39,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 87.47,
    y: 118.68,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 37.42,
    y: 132.45,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 37.42,
    y: 220.68,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 29.79,
    y: 213.39,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 146.43,
    y: 235.67,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 138.78,
    y: 242.96,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 154.7,
    y: 35.7,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 147.06,
    y: 43.01,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 95.93,
    y: 36.46,
    width: 13.69,
    height: 5.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 22.58,
    y: 149.25,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 22.58,
    y: 254.7,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 22.58,
    y: 254.7,
    width: 207.94,
    height: 5.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.15,
    y: 70.71,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 50.17,
    y: 73.73,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.22 73.73 81.22 79.85 50.17 110.9 50.17 96.18 72.64 73.73 81.22 73.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.22 105.81 81.22 120.52 77.27 124.47 62.56 124.47 81.22 105.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.22 99.36 81.22 102.46 59.21 124.47 56.11 124.47 81.22 99.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.51 73.73 50.17 93.06 50.17 86.97 63.42 73.73 69.51 73.73"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.17,
    y: 88.27,
    width: 31.05,
    height: 3.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.02,
    y: 70.71,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 111.03,
    y: 73.73,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.09 73.73 142.09 79.85 111.03 110.9 111.03 96.18 133.5 73.73 142.09 73.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.09 105.81 142.09 120.52 138.13 124.47 123.42 124.47 142.09 105.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.09 99.36 142.09 102.46 120.08 124.47 116.97 124.47 142.09 99.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "130.37 73.73 111.03 93.06 111.03 86.97 124.28 73.73 130.37 73.73"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.03,
    y: 88.27,
    width: 31.05,
    height: 3.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.88,
    y: 70.71,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 171.9,
    y: 73.73,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.95 73.73 202.95 79.85 171.9 110.9 171.9 96.18 194.36 73.73 202.95 73.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.95 105.81 202.95 120.52 198.99 124.47 184.29 124.47 202.95 105.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.95 99.36 202.95 102.46 180.94 124.47 177.84 124.47 202.95 99.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.23 73.73 171.9 93.06 171.9 86.97 185.14 73.73 191.23 73.73"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 171.9,
    y: 88.27,
    width: 31.05,
    height: 3.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.15,
    y: 163.8,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 50.17,
    y: 166.82,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.22 166.82 81.22 172.93 50.17 203.99 50.17 189.27 72.64 166.82 81.22 166.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.22 198.9 81.22 213.61 77.27 217.56 62.56 217.56 81.22 198.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.22 192.45 81.22 195.55 59.21 217.56 56.11 217.56 81.22 192.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "69.51 166.82 50.17 186.15 50.17 180.06 63.42 166.82 69.51 166.82"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.17,
    y: 181.36,
    width: 31.05,
    height: 3.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 135.35,
    y: 224.94,
    width: 12.22,
    height: 5.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.1,
    y: 163.8,
    width: 41.38,
    height: 96.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 111.26,
    y: 170.11,
    width: 29.07,
    height: 79.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.33 234.56 140.33 248.32 138.79 249.86 125.02 249.86 140.33 234.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.33 170.11 140.33 174.8 111.26 203.87 111.26 190.11 131.26 170.11 140.33 170.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.33 180.48 140.33 183.38 111.26 212.45 111.26 209.55 140.33 180.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.33 212.42 140.33 215.32 111.26 244.39 111.26 241.49 140.33 212.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.32 170.11 111.26 178.17 111.26 172.47 113.62 170.11 119.32 170.11"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 142.18,
    y: 219.9,
    width: 2.55,
    height: 8.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.26,
    y: 217.24,
    width: 29.07,
    height: 2.66
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.88,
    y: 163.8,
    width: 37.09,
    height: 56.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 171.9,
    y: 166.82,
    width: 31.05,
    height: 50.75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.95 166.82 202.95 172.93 171.9 203.99 171.9 189.27 194.36 166.82 202.95 166.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.95 198.9 202.95 213.61 198.99 217.56 184.29 217.56 202.95 198.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.95 192.45 202.95 195.55 180.94 217.56 177.84 217.56 202.95 192.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.23 166.82 171.9 186.15 171.9 180.06 185.14 166.82 191.23 166.82"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 171.9,
    y: 181.36,
    width: 31.05,
    height: 3.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m74.41,260.54s-1.58-7.34-4.74-8.53-5.09,2.18-5.09,2.18c0,0-.74-7.06-5.25-9.17-4.5-2.11-7.85,2.21-7.85,2.21,0,0-3.44-8.96-9.59-8.96s-9.24,13.1-9.24,13.1c0,0-3.63-3.9-7.34-1.7-3.71,2.2-3.72,10.86-3.72,10.86h52.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m98.09,260.54h-29.26s.06-4.35,2.94-5.51c1.6-.7,3.47-.25,4.58,1.1,0,0,1.17-8.01,6.54-8.01s7.93,6.91,7.93,6.91c.93-1.36,2.58-2.03,4.2-1.7,2.95.39,3.07,7.21,3.07,7.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m220.03,260.54s-1.58-7.34-4.74-8.53-5.09,2.18-5.09,2.18c0,0-.74-7.06-5.25-9.17-4.5-2.11-7.85,2.21-7.85,2.21,0,0-3.44-8.96-9.59-8.96s-9.24,13.1-9.24,13.1c0,0-3.63-3.9-7.34-1.7-3.71,2.2-3.72,10.86-3.72,10.86h52.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "251.14 54.02 247.2 61.35 126.56 11.38 5.92 61.35 1.98 54.02 126.56 3.79 251.14 54.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "253.12 51.39 249.12 58.89 126.56 5.72 4 58.89 0 51.39 126.56 0 253.12 51.39"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.73,
    y: 175.05,
    width: 15.33,
    height: 14.22,
    rx: 1.61,
    ry: 1.61
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m153.42,186.11v-5.9c-.37.17-1.03.31-1.43.34v-1.28c.75-.14,1.5-.56,1.96-1.06h1.21v7.9h-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m162.8,182.12c0,2.17-.69,4.14-3.03,4.14s-3.03-1.9-3.03-4.09.79-4.09,3.07-4.09,3,1.8,3,4.04Zm-4.29.03c0,1.45.17,2.74,1.28,2.74s1.23-1.21,1.23-2.76-.18-2.68-1.22-2.68-1.3.99-1.3,2.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 163.63,
    cy: 176.48,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 163.63,
    cy: 187.88,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 151.16,
    cy: 176.48,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 151.16,
    cy: 187.88,
    r: 0.25
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b8edb1583ccd12a73aef2995eed5bd39.svg";
export { ForwardRef as ReactComponent };